import { addModal } from 'weblite-web-modal-viewer'
// component
import { JoinHallRequestListModal } from '$comp/modals/join-channel-request-list/join-channel-request-list-modal'

const COMPONENT_ID = 'JoinHallRequestListModal'

export const openJoinHallRequestsModal = (
  props: Parameters<typeof JoinHallRequestListModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showJoinHallRequestsModal = async (roomId: string) => {
  return openJoinHallRequestsModal({ roomId })
}

export default {
  [COMPONENT_ID]: {
    Component: JoinHallRequestListModal,
  },
}
